document.addEventListener('DOMContentLoaded', function() {
  const form = document.querySelector('.model-finder__form');
  const submitButton = document.querySelector('.model-finder__submit');
  const heroWrapper = document.querySelector('.hero-wrapper');
  const sectionId = heroWrapper ? heroWrapper.querySelector('[data-section-id]')?.getAttribute('data-section-id') : '';

  if (!form || !submitButton || !sectionId) return;

  const selectorWrappers = Array.from(form.querySelectorAll('.model-finder__selector'));

  // Store original button label (text nodes only, excluding SVG)
  const buttonSVG = submitButton.querySelector('svg');
  const originalButtonLabel = Array.from(submitButton.childNodes)
    .filter(n => n.nodeType === Node.TEXT_NODE)
    .map(n => (n.textContent || '').trim())
    .join('').trim();

  // --- Debounce ---
  function debounce(func, wait) {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  // --- Close all open dropdowns ---
  function closeAll(except) {
    selectorWrappers.forEach(w => {
      if (w === except) return;
      w.classList.remove('model-finder__selector--open');
      w.querySelector('.model-finder__selector-inner')?.setAttribute('aria-expanded', 'false');
    });
  }

  // --- Toggle a dropdown open/closed ---
  function toggleDropdown(wrapper) {
    const isOpen = wrapper.classList.contains('model-finder__selector--open');
    closeAll(wrapper);
    wrapper.classList.toggle('model-finder__selector--open', !isOpen);
    wrapper.querySelector('.model-finder__selector-inner')?.setAttribute('aria-expanded', String(!isOpen));
  }

  // --- Set the selected value for a wrapper ---
  function selectOption(wrapper, value, label) {
    const hiddenInput = wrapper.querySelector('.model-finder__select');
    const textSpan = wrapper.querySelector('.model-finder__selector-text');
    const defaultText = textSpan?.getAttribute('data-default-text') || '';

    if (hiddenInput) hiddenInput.value = value;
    if (textSpan) textSpan.textContent = value === '' ? defaultText : label;

    // Update selected state on list items
    wrapper.querySelectorAll('.model-finder__option').forEach(li => {
      li.classList.toggle('model-finder__option--selected', li.dataset.value === value);
    });

    wrapper.classList.remove('model-finder__selector--open');
    wrapper.querySelector('.model-finder__selector-inner')?.setAttribute('aria-expanded', 'false');
  }

  // --- Wire up each selector wrapper ---
  selectorWrappers.forEach(wrapper => {
    const trigger = wrapper.querySelector('.model-finder__selector-inner');
    const list = wrapper.querySelector('.model-finder__dropdown');

    // Store the full initial option list so we can always rebuild the complete set
    wrapper._allOptions = Array.from(wrapper.querySelectorAll('.model-finder__option'))
      .map(li => ({ value: li.dataset.value || '', label: li.textContent.trim() }));

    if (!trigger || !list) return;

    // Open/close on trigger click
    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      toggleDropdown(wrapper);
    });

    // Keyboard support on trigger
    trigger.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleDropdown(wrapper);
      }
      if (e.key === 'Escape') closeAll();
    });

    // Option click
    list.addEventListener('click', (e) => {
      const li = e.target.closest('.model-finder__option');
      if (!li) return;
      if (li.classList.contains('model-finder__option--disabled')) return;
      const value = li.dataset.value || '';
      const isClear = li.classList.contains('model-finder__option--clear');
      const label = isClear
        ? (li.dataset.clearLabel || wrapper.querySelector('.model-finder__selector-text')?.getAttribute('data-default-text') || '')
        : li.textContent.trim();
      selectOption(wrapper, value, label);
      debouncedFetch();
    });
  });

  // Close dropdowns on outside click
  document.addEventListener('click', () => closeAll());

  // --- Update options after AJAX response ---
  function updateUI(responseHTML) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(responseHTML, 'text/html');

    // Product count
    const countEl = doc.querySelector('[data-product-count]');
    const count = countEl ? countEl.textContent.trim() : '';
    const svgOuter = buttonSVG ? buttonSVG.outerHTML : '';
    const hasActiveFilters = selectorWrappers.some(w => w.querySelector('.model-finder__select')?.value);
    if (count && count !== '' && hasActiveFilters) {
      submitButton.innerHTML = `${originalButtonLabel} <span class="model-finder__submit-count">(${count})</span> ${svgOuter}`;
    } else {
      submitButton.innerHTML = `${originalButtonLabel} ${svgOuter}`;
    }

    // Rebuild each dropdown with only the available options from the response
    const responseWrappers = Array.from(doc.querySelectorAll('.model-finder__selector'));

    selectorWrappers.forEach((wrapper, index) => {
      const currentValue = wrapper.querySelector('.model-finder__select')?.value || '';
      const responseWrapper = responseWrappers[index];
      const list = wrapper.querySelector('.model-finder__dropdown');
      if (!responseWrapper || !list) return;

      // All options from response (used to seed _allOptions on first load)
      const responseOptions = Array.from(responseWrapper.querySelectorAll('.model-finder__option'))
        .map(li => ({ value: li.dataset.value || '', label: li.textContent.trim() }));

      // Available = options whose data-count > 0 (or no count attribute = always show)
      const availableValues = new Set(
        Array.from(responseWrapper.querySelectorAll('.model-finder__option'))
          .filter(li => {
            const c = li.dataset.count;
            return c === undefined || c === '' || parseInt(c, 10) > 0;
          })
          .map(li => li.dataset.value || '')
      );

      // If _allOptions was empty (filters not in homepage context), seed from this response.
      // The initial fetch has no filters applied so the response contains the full option list.
      if (!wrapper._allOptions || wrapper._allOptions.length === 0) {
        wrapper._allOptions = responseOptions;
      }

      // Rebuild the full option list, marking unavailable ones as disabled
      const allOptions = wrapper._allOptions || [];
      list.innerHTML = '';

      allOptions.forEach(item => {
        const li = document.createElement('li');
        li.className = 'model-finder__option';
        if (item.value === currentValue) li.classList.add('model-finder__option--selected');
        if (!availableValues.has(item.value)) li.classList.add('model-finder__option--disabled');
        li.setAttribute('role', 'option');
        li.dataset.value = item.value;
        li.textContent = item.label;
        list.appendChild(li);
      });

      // If a value is selected, add a "clear" option at the bottom
      if (currentValue) {
        const clearLi = document.createElement('li');
        clearLi.className = 'model-finder__option model-finder__option--clear';
        clearLi.setAttribute('role', 'option');
        clearLi.dataset.value = '';
        const textSpan = wrapper.querySelector('.model-finder__selector-text');
        clearLi.dataset.clearLabel = textSpan?.getAttribute('data-default-text') || '';
        clearLi.textContent = '✕ Clear selection';
        list.appendChild(clearLi);
      }
    });
  }

  // --- Fetch filtered options from Section Rendering API ---
  async function fetchFilteredOptions() {
    const params = new URLSearchParams();

    selectorWrappers.forEach(wrapper => {
      const input = wrapper.querySelector('.model-finder__select');
      if (input && input.value) {
        params.append(input.name, input.value);
      }
    });

    params.set('section_id', sectionId);

    const url = new URL(window.location.origin + '/collections/model-finder');
    url.search = params.toString();

    try {
      const response = await fetch(url.toString());
      const html = await response.text();
      updateUI(html);
    } catch (err) {
      console.error('Model finder fetch error:', err);
    }
  }

  const debouncedFetch = debounce(fetchFilteredOptions, 250);

  // --- Form submit: build clean URL ---
  form.addEventListener('submit', function(e) {
    const params = new URLSearchParams();
    selectorWrappers.forEach(wrapper => {
      const input = wrapper.querySelector('.model-finder__select');
      if (input && input.value) {
        params.append(input.name, input.value);
      }
    });

    if (params.toString()) {
      e.preventDefault();
      window.location.href = form.action + '?' + params.toString();
    }
  });

  // --- Initial fetch to show product count on load ---
  fetchFilteredOptions();
});
